
const digest = 'c89c8e9cd7da392dad7e0428ba79ba1b2e5e3917f0ed1e5f7d9314e99929f598';
const classes = {"wrapper":"_wrapper_1r2fz_1","input":"_input_1r2fz_4"};
const css = `._wrapper_1r2fz_1 {
  position: relative;
}
._wrapper_1r2fz_1 ._input_1r2fz_4 {
  border: 1px solid #c1cbe4 !important;
  min-height: 55px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 15px;
  box-shadow: inset 0 3px 0 0 rgba(198, 214, 240, 0.5);
  padding: 16px 40px 16px 20px !important;
  color: #000;
  background-color: #dce7fa;
  position: relative;
  width: 100%;
}
._wrapper_1r2fz_1 ._input_1r2fz_4.is-invalid {
  border-color: #d81616 !important;
}
._wrapper_1r2fz_1 img {
  height: 16px;
  position: absolute;
  right: 20px;
  top: calc(50% - 8px);
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  